import { render, staticRenderFns } from "./OverviewPage.vue?vue&type=template&id=ef528b80&scoped=true&"
import script from "./OverviewPage.vue?vue&type=script&lang=ts&"
export * from "./OverviewPage.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewPage.vue?vue&type=style&index=0&id=ef528b80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef528b80",
  null
  
)

export default component.exports